/**
 * Force small screen and portrait orientation for devices
 * which might change the availableWidth/availableHeight ratio
 * when keyboard opens - mobile devices.
 *
 * Note: Android chat input was losing focus
 *      when keyboard opened because isDesktop caused rerender based on
 *      availableWidth/availableHeight ratio change. Thats why we use
 *      minimal screenWidth 414px.
 *
 * For test:
 *    - Open Samsung Galaxy S23 Ultra with Firefox browser (browserstack.com).
 *    - Open player in a fullscreen with livestream chat enabled.
 *    - Type something in chat input to trigger keyboard.
 *    - Keyboard should input should not loose focus and keyboard should stay open.
 *
 * Warning: window.screen.width and window.screen.height are not reliable on iOS devices.
 *          The values do not switch when the device is rotated to landscape, so this function
 *          thinks every iOS device is in portrait mode.
 * @returns
 */
export function forceSmallPortraitLayout() {
    const { width: screenWidth } = typeof window !== 'undefined' ? window.screen : { width: 0 };
    return !screenWidth || screenWidth < 414;
}
